import { Component, OnChanges, SimpleChange, Input, ViewChild, TemplateRef } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

import { BsModalService, BsModalRef  } from 'ngx-bootstrap/modal';

marker('tachomat.common.msg.please-wait');

@Component({
	selector: 'tacho-full-page-loader',
	templateUrl: './full-page-loader.component.html',
	styleUrls: ['./full-page-loader.component.scss']
})
export class FullPageLoaderComponent implements OnChanges {
	@Input() message: string = 'tachomat.common.msg.please-wait';
	@Input() show: boolean = true;

	@ViewChild('modalTemplate') modalTemplateRef: TemplateRef<any>;

	modalRef: BsModalRef | undefined;

	constructor(private modalService: BsModalService) {}

	private getConfig() {
		return {
			backdrop: true,
			ignoreBackdropClick: true,
			keyboard: false,
			class: `full-page-modal`,
			animated: false
		};
	}

	private openModal() {
		this.modalRef = this.modalService.show(
			this.modalTemplateRef,
			this.getConfig()
		);
	}

	ngOnChanges(changes: {show: SimpleChange}) {
		if (changes.show) {
			if (changes.show.currentValue === true) {
				if (this.modalTemplateRef) {
					const context = this;
					setTimeout(function() {
						context.openModal();
					}, 0);
				}
			} else if (this.modalRef) {
				this.modalRef.hide();
			}
		}
	}

}
